import React from 'react';
import { Route, useNavigate } from 'react-router-dom';
import UserDashboardLayout from '../../UserDashboard/UserDashboardLayout';
import OverviewPage from '../../UserDashboard/OverviewPage';
import OperationsPage from '../../UserDashboard/OperationsPage';
import RoomsPage from '../../UserDashboard/RoomsPage';
import EfficacyPage from '../../UserDashboard/EfficacyPage';
import ReportsPage from '../../UserDashboard/ReportsPage';
import SubscriptionPage from '../../UserDashboard/SubscriptionPage';
import MembersPage from '../../UserDashboard/MembersPage';
import Robots from '../../User-app/Robots';
import UserMapPage from '../../User-app/RobotMap';
import PaymentPlanView from '../../User-app/paymentplan';
import {
  USER_APP_ROBOTS_PATH,
  USER_SUBSCRIPTION_PLANS_PATH,
  USER_CONTRACT_CHECKOUT_PATH,
  USER_APP_MAPS_PATH,
} from '../../User-app/paths';

export {
  USER_APP_ROBOTS_PATH,
  USER_SUBSCRIPTION_PLANS_PATH,
  USER_CONTRACT_CHECKOUT_PATH,
  USER_APP_MAPS_PATH,
};

function SubscriptionPlansPage() {
  const navigate = useNavigate();
  return (
    <PaymentPlanView onPaymentSuccess={() => navigate(USER_APP_ROBOTS_PATH, { replace: true })} />
  );
}

/** Shared shell (fixed header + drawer); `/client/*` uses dashboard chrome, `/user-app/*` is body-only. */
export const clientDashboardRoutes = [
  <Route key="user-portal" element={<UserDashboardLayout />}>
    <Route path="/client">
      <Route index element={<OverviewPage />} />
      <Route path="overview" element={<OverviewPage />} />
      <Route path="operations" element={<OperationsPage />} />
      <Route path="rooms" element={<RoomsPage />} />
      <Route path="efficacy" element={<EfficacyPage />} />
      <Route path="reports" element={<ReportsPage />} />
      <Route path="subscription" element={<SubscriptionPage />} />
      <Route path="members" element={<MembersPage />} />
    </Route>
    <Route path="/user/subscription/plans" element={<SubscriptionPlansPage />} />
    <Route path="/user/subscription/contract-checkout" element={<SubscriptionPlansPage />} />
    <Route path="/user-app">
      <Route path="robots" element={<Robots />} />
      <Route path="maps" element={<UserMapPage />} />
    </Route>
  </Route>,
];
